// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__7XUix","box":"WorkspacesBox_box__2sxuX","node":"WorkspacesBox_node__2Etii"};